export const subject_page__template: Record<string, string> = {
  0: "Text",
  1: "Title",
  2: "Video",
  3: "Text with image",
  4: "Image with text",
}
